module.exports = __webpack_public_path__ + "static/media/polygon.add683d5.svg";